import { ClientToJsInterface } from './clientToJsInterface';
import { JsToClientInterface } from './jsToClientInterface';

export abstract class AClient {
    public static show(): void {
        throw new Error('Not implemented');
    }

    public static hide(): void {
        throw new Error('Not implemented');
    }

    public static embed(): void {
        throw new Error('Not implemented');
    }

    public static setClientSize(_widthPercent: number, _heightPercent: number): void {
        throw new Error('Not implemented');
    }

    public static stretchClient(): void {
        throw new Error('Not implemented');
    }

    public static getClientToJsInterface(): ClientToJsInterface {
        throw new Error('Not implemented');
    }

    public static getJsToClientInterface(): JsToClientInterface {
        throw new Error('Not implemented');
    }

    public static clientApiReady(): Promise<void> {
        throw new Error('Not implemented');
    }
}
